import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m17.852 8.879-2.625 2.625a.843.843 0 0 1-1.23 0 .843.843 0 0 1 0-1.23l1.12-1.149H6.75a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875h8.367l-1.12-1.121a.843.843 0 0 1 0-1.23.843.843 0 0 1 1.23 0l2.625 2.624a.843.843 0 0 1 0 1.23m-9.106 9.625-2.625-2.625a.843.843 0 0 1 0-1.23l2.625-2.626a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23l-1.12 1.122h8.394a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875H8.855l1.122 1.148a.843.843 0 0 1 0 1.23.843.843 0 0 1-1.23 0"
    }, null, -1)
  ]))]))
}
export default { render: render }